import React, { useMemo, useState } from "react";
import { TabGroup, TabPanels } from "@headlessui/react";
import { useSelectedPlanContext } from "../../../contexts/SelectedPlanContext";
import { usePageSettings } from "../../../contexts/PageSettingsContext";
import { getCheckoutTabs } from "../../../utils/checkoutTabs";
import TabNavigation from "./TabNavigation";
import TabContent from "./TabContent";
import OrderSummaryComponent from "../checkout/order-summary/OrderSummary";

const CheckoutFormTabs = ({ addons, addAddon, removeAddon, currentTab, setCurrentTab, pageContext, legalUrl }) => {
	const { selectedPlan } = useSelectedPlanContext();
	const { translations } = usePageSettings();
	const [orderNumber, setOrderNumber] = useState("");
	const [totalPrice, setTotalPrice] = useState(null);

	// Dynamically fetch the appropriate tabs for the current service
	const tabs = useMemo(
		() => getCheckoutTabs(selectedPlan.service, translations),
		[selectedPlan.service, translations]
	);

	return (
		<TabGroup selectedIndex={currentTab} manual className="h-full flex flex-col">
			{/* Top tab navigation */}
			<div className="w-full px-4 md:px-0">
				<TabNavigation tabs={tabs} currentTab={currentTab} setCurrentTab={setCurrentTab} />
			</div>

			{/* Render each tab's content */}
			<TabPanels className="w-full flex-1">
				{tabs.map((tab, index) => (
					<TabContent
						key={index}
						tab={tab}
						addons={addons}
						addAddon={addAddon}
						removeAddon={removeAddon}
						OrderSummary={
							<OrderSummaryComponent
								addons={addons}
								currentTab={currentTab}
								setCurrentTab={setCurrentTab}
								setOrderNumber={setOrderNumber}
								pageContext={pageContext}
								onTotalPriceChange={setTotalPrice}
								legalUrl={legalUrl}
							/>
						}
						currentTab={currentTab}
						orderNumber={orderNumber}
						pageContext={pageContext}
						totalPrice={totalPrice}
					/>
				))}
			</TabPanels>
		</TabGroup>
	);
};

export default CheckoutFormTabs;
